<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'activitiesCrud'"
          :cruduser_id="$t('Activity')"
          :newText="$t('Add') + '  ' + $t('New')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
          :extra="extra"
          @restart="restart"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "activitiesTable",
      showMessageImport: false,
      activitiesCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "vehicle_id",
        "status",
        "start_date",
        "end_date",
        "actual_start_date",
        "actual_end_date",
        "actions",
      ],
      tableData: [
        "id",
        "name",
        "area_id",
        "vehicle_id",
        "status",
        "start_date",
        "end_date",
        "actual_start_date",
        "actual_end_date",
      ],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["name","status"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("id"),
          name: this.$t("Name"),
          user_id: this.$t("User"),
          vehicle_id: this.$t("Vehicle"),
          start_date: this.$t("start_date"),
          end_date: this.$t("end_date"),
          actual_start_date: this.$t("actual_start_date"),
          actual_end_date: this.$t("actual_end_date"),
          actions: this.$t("action"),
        },
        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        listColumns: {
          status: [
            { id: 0, text: "Não Iniciado" },
            { id: 1, text: "Iniciado" },
            { id: 2, text: "Finalizado" },
            { id: 3, text: "Em remoção" },
          ],
        },
        templates: {
          user_id: (h, row) => (row.user ? row.user.name : ""),
          vehicle_id: (h, row) => (row.vehicle ? row.vehicle.name : ""),
          status: (h, row) => {
            const badges = {
              0: "badge-warning",
              1: "badge-primary",
              2: "badge-success",
              3: "badge-danger",
            };
            const labels = {
              0: "Não iniciado",
              1: "Iniciado",
              2: "Finalizado",
              3: "Em remoção",
            };
            return (
              <h5>
                <span class={`badge ${badges[row.status]}`}>
                  {labels[row.status]}
                </span>
              </h5>
            );
          },
          start_date: (h, row) =>
            row.start_date ? this.formatDate(row.start_date) : "",
          end_date: (h, row) =>
            row.end_date ? this.formatDate(row.end_date) : "",
          actual_start_date: (h, row) =>
            row.actual_start_date ? this.formatDate(row.actual_start_date) : "",
          actual_end_date: (h, row) =>
            row.actual_end_date ? this.formatDate(row.actual_end_date) : "",
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user", "vehicle"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud view",
          title: "Reiniciar Atividade",
          name: "restart",
          icon: "fas fa-clock",
        },
      ],
      endPoint: "activities",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t("id"),
        name: this.$t("Name"),
        user_id: this.$t("User"),
        vehicle_id: this.$t("Vehicle"),
        start_date: this.$t("start_date"),
        end_date: this.$t("end_date"),
        actual_start_date: this.$t("actual_start_date"),
        actual_end_date: this.$t("actual_end_date"),
        actions: this.$t("action"),
      };
      const texts = {
        filterBy: this.$t("Filter"),
        defaultOption: this.$t("Select"),
      };
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      };
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString.replace(" ", "T")); // Ajusta para ISO válido
      if (isNaN(date.getTime())) return "";

      return new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
    },
    makeFormData() {
      let fd = new FormData();
      fd.append("fileImport", "");
      return fd;
    },
    restart(props, row) {
      let api = this.$store.state.api + "restart_activity/" + props.row.id;
      axios
        .post(api)
        .then(() => {
          this.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          this.$router.push("/activities");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    query(query) {
      let columns = {
        id: this.$t("id"),
        name: "name",
        user_id: "user[name]",
        status: this.$t("status"),
        actions: this.$t("action"),
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {},
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
